// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17_-a","left":"styles_left__yhntO","desktopActions":"styles_desktopActions__36gke","title":"styles_title__2I2NJ"};